import { ReactComponent as AncillaryServiceIcon } from './Ancillary_service_icon.svg';
import { ReactComponent as AccountBalanceIcon } from './Bank_icon.svg';
import { ReactComponent as ArrowIcon } from './Arrow_icon.svg';
import { ReactComponent as BidsIcon } from './Bids_icon.svg';
import { ReactComponent as BredCrumbArrow } from './BredCrumbArrow.svg';
import { ReactComponent as CarIcon } from './Car_icon.svg';
import { ReactComponent as CloseIcon } from './Close_icon.svg';
import { ReactComponent as ConfigurationsIcon } from './Configurations_icon.svg';
import { ReactComponent as CircleOutlinedIcon} from './Paid_icon.svg';
import { ReactComponent as CreditCardIcon } from './credit-card-business-payment-icon.svg';
import { ReactComponent as DubbleCheakIcon } from './Dubble_Cheak_icon.svg';
import { ReactComponent as DashboardIcon } from './dashboard.svg';
import { ReactComponent as EditIcon } from './Edit_icon.svg';
import { ReactComponent as EmployeeIcon } from './Employee_icon.svg';
import { ReactComponent as EnableIcon } from './Enable_icon.svg';
import { ReactComponent as EyeIcon } from './Eye_icon.svg';
import { ReactComponent as FavouriteIcon } from './Favourite_icon.svg';
import { ReactComponent as FolderOpenIcon } from './Folder_Open.svg';
import { ReactComponent as LocationOnIcon } from './Booking_icon.svg';
import { ReactComponent as LogoutIcon } from './Logout_icon.svg';
import { ReactComponent as MoreHorizIcon } from './More_icon.svg';
import { ReactComponent as MyVenueIcon} from './MyVenues_icon.svg';
import { ReactComponent as MessageIcon} from './Reviews_icon.svg';
import { ReactComponent as NorthEastIcon} from './NorthEast_icon.svg';
import { ReactComponent as NotificationIcon} from './Notification_icon.svg';
import { ReactComponent as PaiChartIcon} from './Payment_icon.svg';
import { ReactComponent as SecuirtyGardIcon} from './Secuirty_Gard_icon.svg';
import { ReactComponent as ServingIcon} from './Serving_icon.svg';
import { ReactComponent as SettingIcon } from './Setting_icon.svg';
import { ReactComponent as SubMenuIcon } from './SubMenuIcon.svg';
import { ReactComponent as ServiceRequestIcon } from './ServiceRequestsIcon.svg';
import { ReactComponent as ShareIcon} from './Share_icon.svg';
import { ReactComponent as ToilatIcon} from './Toilat_icon.svg';
import { ReactComponent as UploadImageIcon} from './Upload_Image_icon.svg';
import { ReactComponent as UsersGroupIcon} from './Users_Group_icon.svg';
import { ReactComponent as ViewMoreIcon} from './View_More_icon.svg';
import { ReactComponent as VenueIcon } from './venue.svg';
import { ReactComponent as WatchIcon } from './Watch_icon.svg';
import { ReactComponent as WiFiIcon } from './WiFi_icon.svg';
export {
  AncillaryServiceIcon,
  AccountBalanceIcon,
  ArrowIcon,
  BidsIcon,
  BredCrumbArrow,
  CarIcon,
  CloseIcon,
  ConfigurationsIcon,
  CircleOutlinedIcon,
  CreditCardIcon,
  DubbleCheakIcon,
  DashboardIcon,
  EditIcon,
  EmployeeIcon,
  EnableIcon,
  EyeIcon,
  FavouriteIcon,
  FolderOpenIcon,
  LocationOnIcon,
  LogoutIcon,
  MoreHorizIcon,
  MyVenueIcon,
  MessageIcon,
  NorthEastIcon,
  NotificationIcon,
  PaiChartIcon,
  SecuirtyGardIcon,
  ServingIcon,
  SettingIcon,
  ShareIcon,
  SubMenuIcon,
  ServiceRequestIcon,
  ToilatIcon,
  UploadImageIcon,
  UsersGroupIcon,
  ViewMoreIcon,
  VenueIcon,
  WatchIcon,
  WiFiIcon,
};

export const IconMap = {
  accountBalance: AccountBalanceIcon,
  ancillaryService: AncillaryServiceIcon,
  arrowRight: ArrowIcon,
  breadCrumbArrow:BredCrumbArrow,
  car: CarIcon,
  check: EnableIcon,
  circleOutlined: CircleOutlinedIcon,
  close: CloseIcon,
  configurations: ConfigurationsIcon,
  creditCard: CreditCardIcon,
  dashboard: DashboardIcon,
  doubleCheck: DubbleCheakIcon,
  edit: EditIcon,
  employee: EmployeeIcon,
  eye: EyeIcon,
  favorite: FavouriteIcon,
  FolderOpen:FolderOpenIcon,
  hammer: BidsIcon,
  imageUpload: UploadImageIcon,
  locationOn: LocationOnIcon,
  logout: LogoutIcon,
  message: MessageIcon,
  moreHoriz: MoreHorizIcon,
  myVenue: MyVenueIcon,
  networkWifi: WiFiIcon,
  northEast: NorthEastIcon,
  notification: NotificationIcon,
  paiChart: PaiChartIcon, 
  roomService: ServingIcon, 
  securityGuard: SecuirtyGardIcon, 
  serviceRequest: ServiceRequestIcon,
  subMenue:SubMenuIcon,
  setting: SettingIcon,
  share: ShareIcon,
  toilet: ToilatIcon, 
  usersGroup: UsersGroupIcon,
  venue: VenueIcon,
  viewMore: ViewMoreIcon,
  watch: WatchIcon
};

export default IconMap;